/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FollowingCompany
 */
export interface FollowingCompany {
    /**
     * 企業ID
     * @type {number}
     * @memberof FollowingCompany
     */
    companyId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof FollowingCompany
     */
    companyName: string;
    /**
     * 企業のロゴ画像URL (nullable)
     * @type {string}
     * @memberof FollowingCompany
     */
    logoImageUrl: string | null;
    /**
     * 企業説明文 (nullable)
     * @type {string}
     * @memberof FollowingCompany
     */
    description: string | null;
}

export function FollowingCompanyFromJSON(json: any): FollowingCompany {
    return FollowingCompanyFromJSONTyped(json, false);
}

export function FollowingCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowingCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'logoImageUrl': json['logo_image_url'],
        'description': json['description'],
    };
}

export function FollowingCompanyToJSON(value?: FollowingCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'logo_image_url': value.logoImageUrl,
        'description': value.description,
    };
}

